import React from 'react';
import { UserPlus, CreditCard, Search, MessageCircle } from 'lucide-react';

const steps = [
  {
    icon: UserPlus,
    title: 'Create Account',
    desc: 'Verified through Mobile & Email',
  },
  {
    icon: CreditCard,
    title: 'Pay Membership (₹2500 Only)',
    desc: 'Secure Razorpay/GPay Integration',
  },
  {
    icon: Search,
    title: 'Browse Verified Friends',
    desc: 'Filter by age, gender, language, interest',
  },
  {
    icon: MessageCircle,
    title: 'Send Requests & Start Chatting',
    desc: 'Audio/Video/Chat (After request accepted)',
  },
];

const HowItWorks = () => {
  return (
    <section className="py-16 md:py-24 bg-slate-900">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-heading font-bold text-2xl sm:text-3xl text-white text-center mb-12">
          How It Works
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map(({ icon: Icon, title, desc }, i) => (
            <div
              key={i}
              className="flex flex-col items-center text-center p-6 rounded-2xl bg-slate-800/80 border border-slate-700 hover:border-brand-pink/40 transition-colors"
            >
              <div className="w-14 h-14 rounded-xl bg-brand-pink/20 flex items-center justify-center mb-4">
                <Icon className="h-7 w-7 text-brand-pink" />
              </div>
              <h3 className="font-semibold text-white mb-2">{title}</h3>
              <p className="text-slate-400 text-sm">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
